import React from 'react';
import { Document,Page, View ,Text, Image} from '@react-pdf/renderer'; 
import { styles } from '../../../Layout/styleSheet';

const today = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();

const ReporteGlobalPDFDeIngresosXSucursal = ({ordenes}) => {
    const profile = {
        type: 'Profile',
        name: 'Reporte Global de Ingresos',
        fecha: today,
        profileImageURL: '/images/logo.png',
        display: true,
        about: 'About...',
        id: 1,
        fechaAltaEmpleado:'19/09/2006'
    };

    const HeaderLogo = () => {
        return (
            <View style={styles.col_2}>
                <Image style={styles.logo} src={profile.profileImageURL} />
            </View>
        )
    }  
    const Header = () => {
        return (
            <View style={styles.col_6}>
                <Text style={styles.label}> Tipo de Reporte </Text>
                <Text style={styles.subtext}>{profile.name}</Text>
            </View>
        )
    }  
    const HeaderDate = () => {
        return (
            <View style={styles.col_3}>
                <Text style={[styles.label,{textAlign:'right'}]}> Fecha de reporte </Text>
                <Text style={[styles.subtext,{textAlign:'right'}]}>{profile.fecha}</Text>
            </View>
        )
    } 

     const SeccionTitleTable = ({orden}) => {
        return (
        <>
            <View style={[styles.col_12]}>
                <View style={[styles.row, styles.borders]}>
                    <View style={[styles.col_4,styles.section]}>
                        <view style={[styles.section,{backgroundColor:'#cdcdcd'}]}>
                            <Text style={[styles.label,{textAlign:'center'}]}> {orden.empleado_id} </Text>
                        </view>
                    </View>
                    <View style={[styles.col_8,styles.section]}>
                        <view style={[styles.section,{backgroundColor:'#cdcdcd',textAlign:'center'}]}>
                            <Text style={styles.label}>  {orden.empleado} </Text>
                        </view>
                    </View>
                </View>
            </View>
        </>
        )
    }


    const SeccionTableTitles = () => {
        return (
            <>
                <View style={[styles.col_12]}>
                    <View style={[styles.row, styles.borders]}>
                        <View style={[styles.col_4,styles.section, {backgroundColor:'#cdcdcd',textAlign:'center'}]}>
                            <Text style={styles.label}> - </Text>
                        </View>
                        <View style={[styles.col_4,styles.section, {backgroundColor:'#cdcdcd',textAlign:'center'}]}>
                            <Text style={styles.label}> PEDIDOS </Text>
                        </View>
                        <View style={[styles.col_4,styles.section, {backgroundColor:'#cdcdcd',textAlign:'center'}]}>
                            <Text style={styles.label}>  SUBTOTALES </Text>
                        </View>
                    </View>
                </View>
            </>
        )
    }

    const SeccionTable = ({orden}) => {
        return (
            <>
                <View style={[styles.col_12]}>
                    <View style={[styles.row, styles.borders]}>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}>  </Text>
                            <Text style={styles.label}> EFECTIVO </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}> Pedidos: </Text>
                            <Text style={styles.label}>  {orden.data.efectivo.pedidos} </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}> Subtotal: </Text>
                            <Text style={styles.label}>  ${orden.data.efectivo.subTotal} </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.col_12]}>
                    <View style={[styles.row, styles.borders]}>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}>  </Text>
                            <Text style={styles.label}> TARJETAS </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}> Pedidos: </Text>
                            <Text style={styles.label}>  {orden.data.credito.pedidos} </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}> Subtotal: </Text>
                            <Text style={styles.label}>  ${orden.data.credito.subTotal} </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.col_12]}>
                    <View style={[styles.row, styles.borders]}>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}>  </Text>
                            <Text style={styles.label}> DEVITO </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}> Pedidos: </Text>
                            <Text style={styles.label}> {orden.data.debito.pedidos} </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}> Subtotal: </Text>
                            <Text style={styles.label}>  ${orden.data.debito.subTotal} </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.col_12]}>
                    <View style={[styles.row, styles.borders]}>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}>  </Text>
                            <Text style={styles.label}> TRANSFERENCIA </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}> Pedidos: </Text>
                            <Text style={styles.label}>  {orden.data.transferencia.pedidos} </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.labelMini}> Subtotal: </Text>
                            <Text style={styles.label}> ${orden.data.transferencia.subTotal}</Text>
                        </View>
                    </View>
                </View>
            </>
        )
    }
    const SeccionTableGastos = ({orden}) => {
        return (
            <>
                <View style={[styles.col_12, styles.pad_5, {backgroundColor:'#cdcdcd'}]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col_4]}>
                            <Text style={styles.label}> GASTOS </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.label}> {orden.data.gastos.pedidos} </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.label}> ${orden.data.gastos.subTotal} </Text>
                        </View>
                    </View>
                </View>
            </>
        )
    }
    const SeccionTableTotalEfectivo = ({orden}) => { 
        return (
            <>
                <View style={[styles.col_12, styles.pad_5]}>
                    <View style={[styles.row, styles.borders]}>
                        <View style={[styles.col_8]}>
                            <Text style={styles.label}> TOTAL EFECTIVO </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.label}> ${orden.data.totalEfectivo} </Text>
                        </View>
                    </View>
                </View>
            </>
        )
    }
    const SeccionTableTotal = ({orden}) => {
        return (
            <>
                <View style={[styles.col_12, styles.pad_5, {backgroundColor:'#cdcdcd'}]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col_4]}>
                            <Text style={styles.label}> TOTAL </Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.label}>{orden.data.pedidosTotal}</Text>
                        </View>
                        <View style={[styles.col_4]}>
                            <Text style={styles.label}> ${orden.data.total}</Text>
                        </View>
                    </View>
                </View>
            </>
        )
    }

    const SeccionTables = ({ordenes}) => {
        return (
            <>
                <View style={[styles.col_12]}>
                    <View style={[styles.row]}>
                    {ordenes.map(orden=>
                        <View style={[styles.col_6, styles.pad_5]}>
                            <View style={[styles.row]}>
                                <SeccionTitleTable orden={orden} />
                                <SeccionTableTitles />
                                <SeccionTable orden={orden}/>
                                <SeccionTableGastos orden={orden} />
                                <SeccionTableTotalEfectivo orden={orden}/>
                                <SeccionTableTotal orden={orden}/>
                            </View>
                        </View>
                    )}
                    </View>
                </View>
            </>
        )
    }



    return (
    <Document>
        {/* Start of the document*/}
        <Page size={'A4'} orientation={'landscape'} style={styles.page}>
            <View>
                <View style={styles.row}>
                    <HeaderLogo about={profile.about}></HeaderLogo>
                    <Header about={profile.about}></Header>
                    <HeaderDate about={profile.about}></HeaderDate>
                </View>
                <View style={[styles.row]}>
                    <SeccionTables ordenes={ordenes}/>
                </View>
            </View>
        </Page>
    </Document>
    );
};

export default ReporteGlobalPDFDeIngresosXSucursal;